<template>
  <p v-if="snippet.length === 0" class="bplus-copy">
    {{ copy }}
  </p>
  <p v-else class="bplus-copy">
    {{ snippet }}...
    <span
      ><img
        class="pointer unselectable"
        src="@/assets/img/icons/icon-read-more.png"
        alt=""
        @click="handleReadMoreClick"
    /></span>
  </p>
</template>

<script>
export default {
  props: ["copy"],
  data() {
    return {
      copyLength: 0,
      truncateText: true,
      truncateLengthMax: 400,
      snippet: "",
    };
  },
  mounted() {
    if (this.copy) {
      this.copyLength = this.copy.length;

      if (this.copyLength > this.truncateLengthMax) {
        this.snippet = this.copy.slice(0, this.truncateLengthMax);
      }
    }
  },
  methods: {
    handleReadMoreClick,
  },
};

function handleReadMoreClick() {
  this.snippet = "";
}
</script>
<style lang="scss" scoped>
p {
  overflow-wrap: break-word;
}
</style>
